import { ArrowForwardRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { TranslatorEventSource } from './TranslatorEventSource';
import { ChargingStationEventSource } from './ChargingStationEventSource';

export const TranslatorToChargingStation = () => {
  return (
    <Stack direction={'row'} alignItems="center" spacing={4}>
      <TranslatorEventSource />
      <ArrowForwardRounded
        sx={{ color: (theme) => theme.palette.action.active }}
      />
      <ChargingStationEventSource />
    </Stack>
  );
};
